'use strict';

export default {
  isPromise: function (obj){
    return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
  }
}


// WEBPACK FOOTER //
// ./src/utils.js